import './App.css';
import React from 'react';  // Capital R

function Message() {
  return (  // JSX immediately after return / proper parens
    <>
      <div style={{ paddingTop: "50vh",paddingLeft:"35vw" ,fontWeight:"700",fontFamily:"Oswald",fontSize:"50pt"}}>
        to be provided soon
      </div>
    </>
  );
}

export default Message;
